<template>
  <div class="adhdBannerWrap">
    <section class="sr-adhd" aria-labelledby="adhd-banner-title">
      <p class="eligible">ویژهٔ بزرگسالان ساکن انتاریو</p>
      <div class="sr-adhd-grid">
        <img
          class="photo"
          :src="photo"
          alt="گفت‌وگوی آنلاین در فضای آرام خانه"
          loading="lazy"
        />
        <div class="copy">
          <h2 id="adhd-banner-title">
            هنوز دربارهٔ <span class="latin">ADHD</span><br />سؤال داری؟
          </h2>
          <div class="accent" aria-hidden="true"></div>
          <h3>ارزیابی تخصصی ADHD بزرگسالان</h3>
          <p>
            آنلاین، با روان‌شناس ثبت‌شده در انتاریو<br />
            همراه با گزارش تخصصی، به فارسی یا انگلیسی
          </p>
          <a class="cta" href="https://simiaroom.com/adhd-assessment-ontario/" target="_blank" rel="noopener">
            رزرو جلسهٔ اولیهٔ رایگان
            <svg width="16" height="28" viewBox="0 0 16 28" aria-hidden="true">
              <path d="M1 6L15 0V28L1 22Z" fill="#1B2A4B" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "AdhdOntarioBanner",
  data() {
    return {
      photo: require("../../assets/banners/adhd-banner-photo.jpg"),
    };
  },
};
</script>

<style scoped>
.adhdBannerWrap {
  margin: 8px auto 24px;
  width: min(100%, 1100px);
  padding: 0 12px;
}

.sr-adhd {
  --navy: #1b2a4b;
  --green: #3cbe8b;
  color: var(--navy);
  background: #fff;
  border-radius: 28px;
  overflow: hidden;
  direction: rtl;
  text-align: right;
  padding: 36px 40px;
  box-shadow: 0 12px 40px rgba(27, 42, 75, 0.06);
}

.sr-adhd .eligible {
  margin: 0 0 24px;
  font-size: 17px;
  font-weight: 500;
  color: #2a8460;
}

.sr-adhd-grid {
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
  gap: 32px;
  align-items: center;
}

.sr-adhd .photo {
  width: 100%;
  height: 360px;
  object-fit: cover;
  border-radius: 56px;
  display: block;
}

.sr-adhd .copy h2 {
  margin: 0;
  font-size: clamp(1.7rem, 3vw, 2.6rem);
  font-weight: 700;
  line-height: 1.3;
  color: var(--navy);
}

.sr-adhd .latin {
  font-size: 0.9em;
  direction: ltr;
  unicode-bidi: isolate;
}

.sr-adhd .accent {
  width: 80px;
  height: 3px;
  background: var(--green);
  margin: 18px 0 20px auto;
}

.sr-adhd .copy h3 {
  margin: 0 0 12px;
  font-size: clamp(1.15rem, 1.8vw, 1.5rem);
  font-weight: 700;
  line-height: 1.4;
  color: var(--navy);
}

.sr-adhd .copy p {
  margin: 0;
  font-size: clamp(0.95rem, 1.3vw, 1.15rem);
  line-height: 1.8;
  font-weight: 400;
}

.sr-adhd .cta {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: min(100%, 400px);
  min-height: 58px;
  margin-top: 22px;
  padding: 0 48px 0 28px;
  border-radius: 12px;
  background: var(--green);
  color: var(--navy);
  text-decoration: none;
  font-size: 1.05rem;
  font-weight: 700;
  transition: background 160ms;
}

.sr-adhd .cta:hover {
  background: #6fd6ab;
  color: var(--navy);
}

.sr-adhd .cta svg {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
}

@media (max-width: 900px) {
  .sr-adhd {
    padding: 24px 18px;
  }

  .sr-adhd-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .sr-adhd .photo {
    order: -1;
    height: 240px;
    border-radius: 40px;
  }

  .sr-adhd .cta {
    width: 100%;
  }
}
</style>
